// extracted by mini-css-extract-plugin
module.exports = {"container":"CheckboxCell_container__2iw44"};